var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.162 55.7832C71.162 63.7494 64.7082 70.2049 56.7509 70.2049H15.4003C7.43627 70.2049 0.982422 63.7494 0.982422 55.7832V14.4217C0.982422 6.45555 7.43627 0 15.4003 0H56.7509C64.715 0 71.162 6.45555 71.162 14.4217V55.7832Z",
    fill: "url(#paint0_radial_94_207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9428 19.2989H61.417V9.12449H53.3785H51.7193C51.7193 9.12449 45.6176 8.97546 41.7304 14.0288C41.7304 14.0288 39.0825 16.5284 39.0419 23.8374V31.4716H29.4525V42.2828H39.0419V70.2049H50.1007V42.2828H59.6156L60.9429 31.4716H50.1007V23.8374C50.1211 22.9839 50.5003 19.2244 54.9428 19.2989Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_94_207",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6047 85.9887) scale(94.5226 94.5475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B5998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#3B5998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F83CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/FaceBook.193db2796342b9836199124ef38ec54f.svg";
export { ForwardRef as ReactComponent };